// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3bMMc","cell":"ColumnAccessor_cell__1izmh","firstCellAccent":"ColumnAccessor_firstCellAccent__3axso"};